// Texto simples a partir do HTML do editor (nomes, cargos, frases): para alt, chaves e listas do painel
const ENTITIES = { "&amp;": "&", "&nbsp;": " ", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" };

export function stripHtml(html) {
  if (!html) return "";
  return String(html)
    .replace(/<[^>]*>/g, "")
    .replace(/&(amp|nbsp|lt|gt|quot|#39);/g, (entity) => ENTITIES[entity])
    .trim();
}
